module.exports = __webpack_public_path__ + "static/media/fsg-t1.0dbbe40a.svg";